var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 2.708a.75.75 0 0 1 .75.75v7.522l3.386-3.385a.75.75 0 0 1 1.06 1.06L8.53 13.324a.7.7 0 0 1-.235.158q-.017.006-.034.011a.7.7 0 0 1-.245.048L8 13.541a1 1 0 0 1-.088-.006q-.012 0-.024-.004a.7.7 0 0 1-.212-.066 1 1 0 0 1-.119-.071q-.016-.01-.03-.02l-.057-.052-4.667-4.666-.052-.057a.75.75 0 0 1 1.055-1.056l.057.052 3.387 3.387V3.458a.75.75 0 0 1 .75-.75"
  })));
};
export default Svg16;